/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { canAccessContentAccelerator } from 'bundles/authoring-ai-tools/lib/utils';
import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';

interface ContainerProps {
  children: React.ReactNode;
}

const AuthoringAIContainer = ({ children }: ContainerProps) => {
  if (!canAccessContentAccelerator()) {
    redirectClientOrServer('/');
    return null;
  }
  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthoringAIContainer;
